import { DEFAULT_CATALOG_SLICE_SIZE } from "commons/constants";
import { createPaperMaterialOptionLabel } from "commons/ultilities/option-item/label-ultil";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import {
  IAddPaperMaterial,
  IPaperMaterialProperties,
  IUpdatePaperMaterial,
} from "mobx-stores/_models/paper-inventory/paper-material";
import { BaseBussiness } from "../base";

class PaperMaterialBusiness extends BaseBussiness<
  IPaperMaterialProperties,
  IAddPaperMaterial,
  IUpdatePaperMaterial,
  IPaperMaterialProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }

  public searchPapersAsOptionItems = async (keyword: string) => {
    const products = await this.getLists({
      filter: keyword,
      maxResultCount: DEFAULT_CATALOG_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
    });
    return mapToDistinctOptionItems(
      products.items,
      (x) => x.id,
      (x) => createPaperMaterialOptionLabel(x),
    );
  };
}

export const paperMaterialBusiness = new PaperMaterialBusiness(
  "/api/app/paper-material",
);
